import { jsx } from "react/jsx-runtime";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import { validateTidalLicense } from "../../base/index.js";
function HealthAndSafety(props) {
  return /* @__PURE__ */ jsx(
    HealthAndSafetyIcon,
    {
      "data-testid": "HealthAndSafety",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "HealthAndSafety",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
HealthAndSafety.tidalIconMeta = {
  categories: "miscellaneous",
  name: "HealthAndSafety"
};
validateTidalLicense();
export {
  HealthAndSafety
};
//# sourceMappingURL=HealthAndSafety.js.map
